import React, { useContext, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import AuthLanding from "./pages/authLanding/AuthLanding";
import SignUpSignIn from "./pages/SignUpSignIn/SignUpSignIn";
import Dashboard from "./pages/dashboard/Dashboard";
import PaymentHistory from "./pages/paymentHistory/PaymentHistory";
import BankAccount from "./pages/bankAccount/BankAccount";
import Maintenance from "./pages/maintenance/Maintenance";
import MyAccount from "./pages/myAccount/MyAccount";
import TermsAndCondition from "./pages/termsAndPrivacy/TermsAndCondition";
import PrivacyPolicy from "./pages/termsAndPrivacy/PrivacyPolicy";
import Verification from "./pages/Verification";
import EmailNotVerify from "./pages/EmailNotVerify";
import { Auth as PageAuth } from "./pages/Auth";
import { Context } from "./Utility/ContextManager";

import PrivateContainer from "./components/Container";
import UpdateEmailVerification from "./pages/UpdateEmailVerification";
import { getMemberStatementId } from "./Utility";
const PublicRoute = ({ children, isAuth }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuth) {
      checkAuth();
    }
  }, []);

  const checkAuth = async () => {
    try {
      const memberStatementId = getMemberStatementId();
      await Auth.currentAuthenticatedUser();
      navigate("/Dashboard", { state: { memberStatementId: memberStatementId || null } });
    } catch (error) {
      console.log(error);
    }
  };

  return children;
};

export default function MainRoutes() {
  const { pathname } = useLocation();
  const { user } = useContext(Context);
  useEffect(() => {
    document.title = pathname.split("/")[1] ? pathname.split("/")[1] : "Arrivo Tenant Portal";
  }, [pathname]);

  return (
    <div style={{ height: "100%" }}>
      <Routes>
        <Route
          exact
          path="/"
          element={
            <PublicRoute isAuth={true}>
              <AuthLanding />
            </PublicRoute>
          }
        />
        <Route
          exact
          path="/SignUpSignIn"
          element={
            <PublicRoute>
              <SignUpSignIn />
            </PublicRoute>
          }
        />

        <Route exact path="/TermsAndCondition" element={<TermsAndCondition />} />

        <Route
          exact
          path="/Auth"
          element={
            <PublicRoute isAuth={true}>
              <PageAuth />
            </PublicRoute>
          }
        />
        <Route exact path="/PrivacyPolicy" element={<PrivacyPolicy />} />

        <Route
          exact
          path="/Dashboard"
          element={
            <PrivateContainer>
              <Dashboard />
            </PrivateContainer>
          }
        />

        <Route exact path="/Verification/:id" element={<Verification />} />

        <Route
          exact
          path="/EmailNotVerify"
          element={
            <PrivateContainer isHideSideBar={true}>
              <EmailNotVerify />
            </PrivateContainer>
          }
        />

        <Route exact path="/updateEmailVerfication/:token" element={<UpdateEmailVerification />} />

        <Route
          exact
          path="/PaymentHistory"
          element={
            <PrivateContainer>
              <PaymentHistory />
            </PrivateContainer>
          }
        />
        <Route
          exact
          path="/BankAccount"
          element={
            <PrivateContainer>
              <BankAccount />
            </PrivateContainer>
          }
        />
        {user?.is_member !== 1 && (
          <Route
            exact
            path="/Maintenance"
            element={
              <PrivateContainer>
                <Maintenance />
              </PrivateContainer>
            }
          />
        )}
        <Route
          exact
          path="/MyAccount"
          element={
            <PrivateContainer>
              <MyAccount />
            </PrivateContainer>
          }
        />
      </Routes>
    </div>
  );
}
